// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Internal Imports
import { GlobalUtils } from "../../utils";

import { IMAGE_URLS } from "../../constants";

const {
  PDF,
  PNG,
  JPG,
  JPEG,
  DOC,
  DOCX,
  JSONFILE,
  XLS,
  XLSM,
  XML,
  AVI,
  CSV,
  GIF,
  MOV,
  WEBM,
  M4V,
  MID,
  SVG,
  XLSX,
  PPT,
  PPTX,
  MP4,
  WAV,
  TXT,
  MP3,
  OGG,
  MKV,
  FLAC,
  AAC,
  GP,
  AMR,
  M4A,
  FLV,
} = IMAGE_URLS;

// ICON MAPPING
const imgData = {
  pdf: PDF,
  png: PNG,
  jpg: JPG,
  jpeg: JPEG,
  doc: DOC,
  docx: DOCX,
  json: JSONFILE,
  xls: XLS,
  xlsm: XLSM,
  xml: XML,
  avi: AVI,
  csv: CSV,
  gif: GIF,
  mov: MOV,
  webm: WEBM,
  m4v: M4V,
  mid: MID,
  svg: SVG,
  xlsx: XLSX,
  ppt: PPT,
  pptx: PPTX,
  mp4: MP4,
  wav: WAV,
  txt: TXT,
  mp3: MP3,
  ogg: OGG,
  mkv: MKV,
  flac: FLAC,
  aac: AAC,
  "3gp": GP,
  amr: AMR,
  m4a: M4A,
  flv: FLV,
};

export default class AttachmentItem extends Component {
  state = { isVideo: false };

  componentDidMount() {
    const isVideoAttachment = this.props.Name.split(".");
    if (
      isVideoAttachment[isVideoAttachment.length - 1] === "webm" ||
      isVideoAttachment[isVideoAttachment.length - 1] === "mp4"
    ) {
      this.setState({ isVideo: true });
    }
  }

  bytesToSize = bytes => {
    const sizes = ["Bytes", "KB", "MB"];
    if (bytes === 0) return "0 Byte";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    // eslint-disable-next-line no-restricted-properties
    return `${Math.round(bytes / Math.pow(1024, i), 2)} ${sizes[i]}`;
  };

  _getFileMapping = filename => {
    const extension = filename && filename.split(".").pop();
    return imgData[extension] ? imgData[extension] : imgData.doc;
  };

  render() {
    return (
      <div
        className="attachment-item-container"
        onKeyPress={() => null}
        role="button"
        tabIndex="0"
        onClick={
          !this.props.showLoader
            ? () => this.props.viewFile(this.state.isVideo)
            : () => {}
        }>
        {this.props.showLoader && (
          <span className="attachmentitem-download-leader">Downloading...</span>
        )}
        {this.state.isVideo && (
          <div>
            {" "}
            <video src={this.props.Link} controls width={235} height={150}>
              <track kind="captions" srcLang="en" label="english_captions" />
            </video>
          </div>
        )}
        <div className="attachment-first-section-box">
          <img
            src={this._getFileMapping(this.props.Name)}
            className="attachment-item-image"
            alt="attachment"
          />
          <div className="attachment-item-first-section">
            <span className="attachment-item-name">{this.props.Name}</span>
            {!this.props.isSharedDocument && (
              <span className="attachment-item-trash">
                <FontAwesomeIcon
                  icon={["far", "trash-alt"]}
                  onClick={e => this.props.removeItem(e)}
                  className=""
                />
              </span>
            )}
          </div>
          <div className="attachment-item-size">
            {this.bytesToSize(this.props.FileSize)}
          </div>
        </div>
        <div className="attachment-horizontal-line " />
        <div className="attachment-user-info">
          <span>{this.props.user && this.props.user.name}</span>
          <span>
            {this.props.UploadedAt
              ? GlobalUtils.formatDate(this.props.UploadedAt, "ll") || "-"
              : ""}
          </span>
        </div>
      </div>
    );
  }
}
